import { render, staticRenderFns } from "./AttachmentInfo.vue?vue&type=template&id=6f18cdab&"
import script from "./AttachmentInfo.vue?vue&type=script&lang=js&"
export * from "./AttachmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports